import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getAccount, updateAccount } from '../services/account';

export const useAccount = (token) =>
  useQuery({
    queryKey: ['account'],
    enabled: !!token,
    queryFn: async () => {
      const account = await getAccount(token);
      // eslint-disable-next-line no-console
      console.log('Account data', account);
      return account;
    },
    staleTime: 5 * 60 * 1000,
  });

export const useUpdateAccount = (token) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (updates) => updateAccount(token, updates),
    onMutate: async (updates) => {
      await queryClient.cancelQueries({ queryKey: ['account'] });
      const previous = queryClient.getQueryData(['account']);
      queryClient.setQueryData(['account'], (old) => ({ ...(old || {}), ...(updates || {}) }));
      return { previous };
    },
    onError: (_err, _updates, context) => {
      if (context?.previous) queryClient.setQueryData(['account'], context.previous);
    },
    onSuccess: (data) => {
      if (data) queryClient.setQueryData(['account'], data);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['account'] });
    },
  });
};
